import { OwnerId, OwnerIdType } from 'prove-common'

/**
 * Query-parameter som holder styr på hvor i fordelingen brukeren har navigert.
 * Verdien er en komma-separert kjede av ownerId-er, for eksempel
 * `?fordeling=region:r1,avdeling:a1`.
 */
export const DELEGATION_PATH_PARAM = 'fordeling'

/**
 * Nivåene brukeren kan navigere inn i. Team er ikke med, fordi team er det
 * nederste nivået og vises som kort med antallsvelger i stedet for en egen skjerm.
 */
export const DELEGATION_PATH_LEVELS: OwnerIdType[] = [
  'region',
  'avdeling',
  'seksjon'
]

export const OWNER_TYPE_LABEL: Record<OwnerIdType, string> = {
  user: 'Bruker',
  region: 'Divisjon',
  avdeling: 'Avdeling',
  seksjon: 'Seksjon',
  team: 'Team'
}

export const OWNER_TYPE_PLURAL: Record<OwnerIdType, string> = {
  user: 'brukere',
  region: 'divisjoner',
  avdeling: 'avdelinger',
  seksjon: 'seksjoner',
  team: 'team'
}

/**
 * Tolker query-parameteren til en kjede av ownerId-er. Ugyldige segmenter, og
 * alt som kommer etter dem, forkastes slik at vi alltid ender på en gyldig skjerm.
 */
export const parseDelegationPath = (raw?: string | null): OwnerId[] => {
  if (raw == null || raw.trim().length === 0) return []
  const segments = raw
    .split(',')
    .map((segment) => segment.trim())
    .filter((segment) => segment.length > 0)
  const path: OwnerId[] = []
  for (const segment of segments) {
    if (path.length >= DELEGATION_PATH_LEVELS.length) break
    const ownerId = OwnerId.fromString(segment)
    if (ownerId == null || ownerId.type !== DELEGATION_PATH_LEVELS[path.length])
      break
    path.push(ownerId)
  }
  return path
}

export const serializeDelegationPath = (path: OwnerId[]): string =>
  path.map((ownerId) => ownerId.toString()).join(',')

/**
 * «1 seksjon» / «3 seksjoner».
 */
export const formatUnitCount = (count: number, type: OwnerIdType): string =>
  `${count} ${count === 1 ? OWNER_TYPE_LABEL[type].toLowerCase() : OWNER_TYPE_PLURAL[type]}`
